<template>
  <div :class='componentClasses'>
    <div class="result-heading">
      <h2>{{ config.title }}</h2>
    </div>
    <div class='result-circle'>
      <result-circle :title='circleTitle' :text='circleText' :config='circleConfig' :progress='progress'></result-circle>
    </div>
    <div class="circle-banding">
      <div class="score--message result-message" v-if="displayMessage(progress * 100)">
        <h2>{{ displayMessage(progress * 100) }}</h2>
      </div>
      <div class="score--more result-message" v-if="displayMore(progress * 100)">
        {{ displayMore(progress * 100) }}
      </div>
    </div>
    <div class="result-breakdown" v-if='config.breakdown'>
      <result-breakdown :config='config.breakdown' :bands='config.bands'>
        <template v-slot:default>
          {{ 'ResultBreakdown subcomponent' }}
        </template>
      </result-breakdown>
    </div>
    <div class="comp-type" v-if='debugMode == true'>
      <slot name='comptype'></slot>
    </div>
  </div>
</template>
<script>
import Scoring from '../lib/Scoring.js'
import ResultBreakdown from './ResultBreakdown.vue'
import Circle from './Circle'
export default {
  props: ['config', 'result'],
  components: {
    'result-breakdown': ResultBreakdown,
    'result-circle': Circle
  },
  mixins: [Scoring],
  inject: ['convince', 'theme'],
  data () {
    return {
      componentClasses: ['result-score-component', 'result-component'],
      maxScore: 0,
      score: 0,
      progress: 0,
      scoreBand: null,
      scoreText: '',
      ready: false,
      circleTitle: '',
      circleText: ''
    }
  },
  computed: {
    circleConfig () {
      return {
        stroke: this.config.resultPrimaryColor || this.theme.progressBar.backgroundColor,
        titleColor: this.config.resultSecondaryColor,
        displayAs: this.config.displayAs
      }
    }
  },
  methods: {

    onInit (event) {
      this.ready = true
    },
    showScore () {
      return this.config.displayAs === 'score'
    },
    showPercent () {
      return this.config.displayAs === 'percentage'
    },
    borderThickness () {
      return this.theme.borders.thickness
    },
    update () {
      this.maxScore = this.getMaxScore()
      this.score = this.result.comparison.score
      if (this.maxScore > 0) {
        this.progress = this.score / this.maxScore
      }
      this.scoreBand = this.getScoreBand(this.progress * 100, this.config.bands)
      let band = this.scoreBand.index + 1
      this.componentClasses.push('result-band-' + band)
      if (this.config.displayAs === 'score') {
        this.circleTitle = this.result.comparison.score + '/' + this.getMaxScore()
        this.circleText = ''
      } else {
        this.circleTitle = (this.progress * 100).toFixed(0) + '%'
        this.circleText = this.result.comparison.score + ' / ' + this.getMaxScore()
      }
    }
  },
  created () {
    this.maxScore = this.getMaxScore()
  },
  watch: {
    result: function (result, oldResult) {
      this.update()
    }
  }
}
</script>
<style lang='scss'>
  .result-circle {
    margin-bottom: 1em;
    .score--message.result-message {
      margin-top: 0.5em;
    }
    .score--more.result-message {
      max-width: 350px;
      margin: 1.5em auto;
      text-align: center;
    }
    .circle {
      h2.score-text {
        margin-top: 0.5em;
        font-weight: 300;
        span {
          display: block;
        }
      }
    }
  }
</style>
